/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.key" placeholder="输入用户名/姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addUser()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" prop="uname" label="用户名" width="120">
      </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名" width="120">
      </el-table-column>
      <el-table-column align="center" prop="doctorid" label="doctorid" width="120">
      </el-table-column>
      <el-table-column align="center" prop="ip" label="上次登录IP">
      </el-table-column>
      <el-table-column align="center" prop="login_time" label="上次登录时间">
      </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间">
      </el-table-column>
      <el-table-column align="center" prop="is_lock" label="状态" width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_lock" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.row)"
          active-value="1" inactive-value="0">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editUser(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="resetpwd(scope.row)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="添加用户" :visible.sync="editFormVisible" width="400px" @click='editFormVisible = false' :close-on-click-modal="false">
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="用户名" prop="uname">
          <el-input size="small" v-model="editForm.uname" auto-complete="off" placeholder="请输入用户名" style="width: 260px;"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realname">
          <el-input size="small" v-model="editForm.realname" auto-complete="off" placeholder="请输入姓名" style="width: 260px;"></el-input>
        </el-form-item>
        <el-form-item label="doctor ID" prop="doctorid">
          <el-input size="small" v-model="editForm.doctorid" auto-complete="off" placeholder="请输入doctorid" style="width: 260px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='editFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import { userList,userSave,userLock,userPwd,delUser } from '../../api/baseset'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false,
      // 添加用户
      editForm: {
        uname: '',
        realname: '',
        doctorid:''
      },
      // rules表单验证
      rules: {
        uname: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      },
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        key: ''
      },
      //用户数据
      userData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
       userList(parameter).then(res => {
         this.loading = false
         if (res.code != 0) {
           this.$message({
             type: 'info',
             message: res.msg
           })
         } else {
           this.userData = res.data
           // 分页赋值
           this.pageparm.currentPage = this.formInline.page
           this.pageparm.pageSize = this.formInline.limit
           this.pageparm.total = res.count
         }
       })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.getdata(this.formInline)
    },
    addUser() {
      this.editFormVisible = true;
      this.editForm  = []
    },
    editUser(row) {
      console.log(row)
      this.editFormVisible = true;
      this.editForm = row
    },
    // 修改状态
    editType: function(row) {
      let parm = {id:row.id,is_lock:row.is_lock}
      userLock(parm).then(res => {
        this.loading = false
        if (res.code== 0) {
          this.$message({
            type: 'success',
            message: res.msg
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 添加提交方法
    submitForm(editData) {
      this.loading = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          userSave(this.editForm)
            .then(res => {
              this.loading = false
              if (res.code == 0) {
                this.editFormVisible = false
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除用户
    deleteUser(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          let data = {id:row.id}
          delUser(data)
            .then(res => {
              this.loading = false;
              this.getdata(this.formInline)
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.loading = false;
              this.getdata(this.formInline)
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    // 重置密码
    resetpwd(row) {
      this.$confirm('确定要重置密码吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          let data = {id:row.id}
          userPwd(data)
            .then(res => {
              this.loading = false;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.getdata(this.formInline)
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error('重置密码失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消重置密码！'
          })
        })
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue